import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { NolKoma7to1rem } from '../../GlobalStyles'
import SidebarSubMenu from './SidebarSubMenu'

const Menu = styled.div`
   display: flex;
   align-items: center;
   justify-content: space-between;
   padding: 5px 12px;
   border-bottom: 1px solid black;
   cursor: pointer;
`
export const Left = styled.div`
    font-size: ${NolKoma7to1rem};
    text-transform: uppercase;
`
export const Right = styled.div`
    & > svg {
        font-size: 1.1rem;
    }
`
const SubMenuContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: white;
    transform: ${({ sub }) => sub ? 'translateX(0)' : 'translateX(200%)'};
    transition: transform 500ms ease-out;
`

export default function SidebarMenu({ menu, toggleSidebar }) {
  const [subMenu, setSubMenu] = useState(false)
  const toggleSubMenu = () => setSubMenu(prev => !prev)
  const navigate = useNavigate()
  const menuOnClick = sub => {
      if (sub) {
        toggleSubMenu()
      } else {
        navigate('/lists')
        toggleSidebar()
      }
  }
  return (
    <>
        <Menu onClick={() => menuOnClick(menu.subNav)}>
            <Left>{menu.title}</Left>
            <Right>{menu.subNav && menu.iconNext}</Right>
        </Menu>
        <SubMenuContainer sub={subMenu}>
            <SidebarSubMenu judul={menu.title} subMenuList={menu.subNav ? menu.subNav : null} toggleSubMenu={toggleSubMenu} toggleSidebar={toggleSidebar}/>
        </SubMenuContainer>
    </>
  )
}

// {/* {
//     menu.subNav && (
//         <SubMenuContainer sub={subMenu}>
//             <SidebarSubMenu judul={menu.title} subNavList={menu?.subNav} toggleSubMenu={toggleSubMenu}/>
//         </SubMenuContainer>
//     )
// } */}

